<app-form-input
	[parentForm]="parentForm"
    [disabled]="disabled"

	[value]="adressesComplt.typeRensSelect"

	[label]="step12.gettyperensa"
	[type]="'select'"
    [typeSelect]="optionsSelectType"
    [optionsWithCode]="optionsSelect" [rule]="''"
	[name]="getUid()+'_SepAtt_typerensaSelect'">
	</app-form-input>

<app-type-adresse-complete *ngIf="isAdmEtTech"  [uid]="'admEtTech'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[filtreRG]="'admEtTech'"
[nbIteration]="0"
 [typeAdresseComplete]="adressesComplt?.admEtTech"></app-type-adresse-complete>
 <app-form-input-error *ngIf="isAdmEtTech" [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>

<app-type-annexeATA *ngIf="isAdmOuTech" [admOuTechSelect]="admOuTechSelect()" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [admOuTech]="adressesComplt?.admOuTech"></app-type-annexeATA>

<app-type-adresse-complete  *ngIf="isDocument" [uid]="'document'+getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[filtreRG]="'document'"
[nbIteration]="0"
 [typeAdresseComplete]="adressesComplt?.document"></app-type-adresse-complete>
 <app-form-input-error  *ngIf="isDocument" [activeForm]="parentForm" [name]="getStepId() + rg2" [id]="getStepId() + rg2"></app-form-input-error>

<app-envoi *ngIf="isEnvoi" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [envoi]="adressesComplt?.envoi"></app-envoi>
 <app-form-input-error *ngIf="isEnvoi" [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>

<app-rens-complementaires *ngIf="isRensComplementaires" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [rensComplementaires]="adressesComplt?.rensComplementaires"></app-rens-complementaires>
 <app-form-input-error *ngIf="isRensComplementaires" [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>
